import axios from "axios";

export const apiPesquisaSatisfacao = axios.create({
    // baseURL: 'http://localhost:8081',
    baseURL: "https://servicosapi.ifollow.com.br/"
  });

export default apiPesquisaSatisfacao;